import { SET_UPLOAD_PROGRESS_METRIC, RESET_UPLOAD_PROGRESS_METRIC, REMOVE_COMPLETED_UPLOAD_PROGRESS_METRIC } from '../../actions/dsr-actions-types'

const INITIAL_STATE_UPLOAD_FILES = { fileUploadProgress: {} }

export function setUploadProgressReducer(state = INITIAL_STATE_UPLOAD_FILES, action) {
  switch (action.type) {
    case RESET_UPLOAD_PROGRESS_METRIC:
      return INITIAL_STATE_UPLOAD_FILES
    case SET_UPLOAD_PROGRESS_METRIC: {
      const { subwidgetId, postId, percentProcessed } = action.payload;
      const key = subwidgetId || postId || 'global' // Default to "global" for uploads not related to subwidgets (e.g. post creation)
      return {
        ...state,
        fileUploadProgress: {
          ...state.fileUploadProgress,
          [key]: percentProcessed 
        }
      };
    }
    case REMOVE_COMPLETED_UPLOAD_PROGRESS_METRIC: {
      const { postId, subwidgetId } = action.payload || {};
      const key = subwidgetId || postId || "global"; // Determine the key to filter by
    
      // Validate if the key exists before filtering
      if (!state.fileUploadProgress[key]) {
        console.warn(`Key "${key}" not found in fileUploadProgress.`);
        return state; // If no matching key exists, return current state
      }

      // Filter out the entry where the key matches
      const newProgress = Object.fromEntries(
        Object.entries(state.fileUploadProgress).filter(([k, _]) => k !== key)
      );
    
      return {
        ...state,
        fileUploadProgress: newProgress
      };
    }
    default:
      return state;
  }
}